/* Videos verticales (9:16). src diferido, play solo con >=50% visible, boton pausa/play (WCAG 2.2.2),
   sin autoplay con prefers-reduced-motion. Si faltan poster y video, el bloque se elimina. */
(function () {
  var S = (window.Rosvelet && window.Rosvelet.strings) || {};
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  var PLAY = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14l11-7z"/></svg>';
  var PAUSE = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M8 5v14M16 5v14"/></svg>';
  var hasIO = 'IntersectionObserver' in window;

  function sync(st) {
    var on = !st.v.paused;
    st.el.classList.toggle('is-playing', on);
    st.btn.innerHTML = on ? PAUSE : PLAY;
    st.btn.setAttribute('aria-label', (on ? S.videoPause : S.videoPlay).replace('__NAME__', st.el.dataset.name));
  }
  function load(st) { if (!st.v.getAttribute('src')) st.v.src = st.v.dataset.src; }
  function play(st) {
    load(st);
    var pr = st.v.play();
    if (pr && pr.catch) pr.catch(function () { sync(st); }); // autoplay bloqueado: queda el poster con su boton
  }
  function gone(st) {
    (st.el.closest('[data-vid-host]') || st.el).remove();
    document.dispatchEvent(new CustomEvent('vid:gone'));
  }
  function still(st) { st.btn.hidden = true; }

  var near = hasIO && new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (e.isIntersecting) { near.unobserve(e.target); load(e.target._st); } });
  }, { rootMargin: '300px 0px' });
  var seen = hasIO && new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      var st = e.target._st, vis = e.intersectionRatio >= 0.5;
      if (vis && !st.user && !reduce.matches && st.v.paused) play(st);
      else if (!vis && !st.v.paused) st.v.pause();
    });
  }, { threshold: [0, 0.5] });

  function setup(el) {
    el.dataset.ready = '1';
    var v = el.querySelector('video');
    el.insertAdjacentHTML('beforeend', '<button class="vid__btn" type="button" hidden></button>');
    var st = { el: el, v: v, btn: el.querySelector('.vid__btn'), user: false, poster: false, video: true };
    el._st = st;
    sync(st);
    st.btn.addEventListener('click', function () {
      if (v.paused) { st.user = false; play(st); } else { st.user = true; v.pause(); }
    });
    v.addEventListener('play', function () { sync(st); });
    v.addEventListener('pause', function () { sync(st); });
    v.addEventListener('error', function () { if (!v.getAttribute('src')) return; st.video = false; still(st); if (!st.poster) gone(st); });

    /* Sin HEAD previo: el video se asume disponible y, si el archivo falta, el evento 'error' lo degrada. */
    function settle() {
      if (!st.poster) v.removeAttribute('poster');
      st.btn.hidden = false;
      if (hasIO) { near.observe(el); seen.observe(el); }
    }
    var img = new Image();
    img.onload = function () { st.poster = true; settle(); };
    img.onerror = function () { settle(); };
    img.src = v.getAttribute('poster');
  }

  window.RVVideo = {
    init: function (scope) {
      Array.prototype.forEach.call((scope || document).querySelectorAll('.vid:not([data-ready])'), setup);
    }
  };
})();
